import { render, staticRenderFns } from "./batch-process-analysis-result-modal.vue?vue&type=template&id=bd741142"
import script from "./batch-process-analysis-result-modal.vue?vue&type=script&lang=js"
export * from "./batch-process-analysis-result-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports